/**
 * TODO search backend enum if exists
 * @type {{text: string, alternative: string}}
 */
export const medicalInfoTypes = {
  text: "text",
  alternative: "alternatives",
};
